import { Flex, GButton, Text } from '@gazin/ecommerce-ui'

type VoltageConfirmationModalProps = {
  confirmVoltage: () => void
  onClose: () => void
  setDisplayConfirmationVoltage: React.Dispatch<React.SetStateAction<boolean>>
  voltageProduct: { slug?: string; valor?: string }
}

export const VoltageConfirmationModal: React.FC<
  VoltageConfirmationModalProps
> = ({ confirmVoltage, onClose, voltageProduct }) => {
  return (
    <>
      <Text
        color="#4D5163"
        fontSize="1.5rem"
        fontWeight="600"
        mb="1rem"
        textAlign="center"
      >
        Tem certeza que deseja continuar?
      </Text>

      <Flex alignItems="center" color="#646981" flexDir="column">
        <Text mb="0">O produto selecionado é de:</Text>
        <Text fontWeight="600" mb="2rem">
          {voltageProduct?.valor ? voltageProduct.valor : ''}
        </Text>
      </Flex>

      <Flex alignItems="center" gap="1rem" justifyContent="center" width="100%">
        <GButton
          _active={{
            bgColor: 'primary.500',
            borderColor: 'primary.500',
            color: 'white',
          }}
          _hover={{
            bgColor: 'white',
            color: 'primary.500',
          }}
          borderColor="primary.500"
          color="primary.500"
          flex="1"
          h="3rem"
          label="Cancelar"
          onClick={onClose}
          padding="0.625rem"
          variantType="outline"
        />

        <GButton flex="1" h="3rem" label="Continuar" onClick={confirmVoltage} />
      </Flex>
    </>
  )
}
